import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';
import {MENU, OPSMENU} from './menu-items';
import {SimplebarAngularModule} from 'simplebar-angular';
import {MenuItem} from './menu-model';
import {NavigationEnd, NavigationStart, Router, RouterModule} from '@angular/router';
import {
  NgbCollapse,
  NgbCollapseModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
// import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {findAllParent, findMenuItem} from './utils';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PermissionsService} from '../../Services/permissions.service';
import {NotificationService} from '../../Services/notification.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styles: ``,
  standalone: false
})
export class SideMenuComponent implements OnInit, AfterViewInit {
  menuItems: MenuItem[] = [];
  activeMenuItems: string[] = [];
  render = inject(Renderer2);
  selectedValue = '';
  modeOperations: boolean;
  filteredObject: any;

  constructor(
    private router: Router,
    public p: PermissionsService,
    public notify: NotificationService,
    // public translate: TranslateService
  ) {
    // translate.setDefaultLang('en');

    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
        this.hideBackdrop();
      }
      if (event instanceof NavigationStart) {
        // stuff here
      }
    });
  }

  ngOnInit(): void {

    const modeOps = localStorage.getItem('modeOperations');
    // console.log('modeOps: ' + modeOps);
    this.modeOperations = modeOps === 'true';
    // console.log('modeOperations: ' + this.modeOperations);
    if (!this.modeOperations || modeOps === null) {
      this.selectedValue = 'option1';
    } else {
      this.selectedValue = 'option2';
    }

    this.initMenu();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.activateMenu();
      this._fixSimplebarOverflow();
    });
  }

  private _fixSimplebarOverflow(): void {
    // Simplebar sets overflow:hidden as inline styles at runtime, beating !important CSS rules.
    // We must override inline styles directly via the renderer.
    const wrapper = document.querySelector('.leftside-menu .simplebar-content-wrapper') as HTMLElement;
    const content = document.querySelector('.leftside-menu .simplebar-content') as HTMLElement;
    if (wrapper) {
      this.render.setStyle(wrapper, 'overflow-x', 'visible');
    }
    if (content) {
      this.render.setStyle(content, 'overflow', 'visible');
      this.render.setStyle(content, 'padding-right', '0');
    }
  }

  /**
   * Toggles the navigation state and updates the operation mode.
   *
   * @param {any} event - The event object triggering the navigation switch.
   * @return {void} This method does not return a value.
   */
  switchNav(event: any) {
    this.modeOperations = !this.modeOperations;
    localStorage.setItem('modeOperations', String(this.modeOperations));
    if (this.modeOperations) {
      this.selectedValue = 'option2';
    } else {
      this.selectedValue = 'option1';
    }
    this.initMenu();
  }

  /**
   * initialize menuitems
   */
  toggleCollapsed(menu: MenuItem, collapsed: boolean): void {
    menu.collapsed = collapsed;
  }

  initMenu(): void {
    if (this.modeOperations) {
      this.menuItems = OPSMENU;
    } else {
      this.menuItems = MENU;
    }
  }

  // todo - base this on some system setting so you cn push messages to a user and force them to see.
  toggleMessageBox() {
    // console.log('toggle message box');
    const x = document.getElementById('message-box');
    if (x) {
      x.classList.toggle('d-none');
    }
  }

  /**
   * Searches for all occurrences of a specific key within a nested object and returns the values associated with that key.
   *
   * @param {Object} obj - The object to be searched.
   * @param {string} targetKey - The key to search for within the object.
   * @return {any[]} An array of values associated with all occurrences of the target key in the object.
   */
  searchInObject(obj: any, targetKey: string): any[] {
    let result: any[] = [];

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (key === targetKey) {
          result.push(obj[key]);
        } else if (typeof obj[key] === 'object') {
          result = result.concat(this.searchInObject(obj[key], targetKey));
        }
      }
    }

    return result;
  }

  /**
   * Activates the menu based on the current window location.
   * It identifies the corresponding menu item on the side navigation
   * and updates the active menu items list accordingly. Additionally, it ensures
   * the state of the menu, collapsing and expanding items as needed.
   *
   * @return {void} Does not return a value.
   */
  activateMenu(): void {
    const div = document.querySelector('.side-nav');
    let matchingMenuItem = null;

    if (div) {
      const items: HTMLCollectionOf<HTMLAnchorElement> =
        div.getElementsByClassName(
          'side-nav-link-ref'
        ) as HTMLCollectionOf<HTMLAnchorElement>;

      // First try exact match; fall back to longest-prefix match so that
      // detail/edit routes (e.g. /invoice/123) keep the parent list item active.
      let bestPrefixLength = 0;
      for (let i = 0; i < items.length; ++i) {
        const itemPath = items[i].pathname;
        if (window.location.pathname === itemPath) {
          matchingMenuItem = items[i];
          break;
        }
        if (
          itemPath &&
          itemPath !== '/' &&
          window.location.pathname.startsWith(itemPath) &&
          itemPath.length > bestPrefixLength
        ) {
          bestPrefixLength = itemPath.length;
          matchingMenuItem = items[i];
        }
      }

      if (matchingMenuItem) {
        const mid = matchingMenuItem.getAttribute('data-menu-key');
        const activeMt = findMenuItem(this.menuItems, mid!);

        if (activeMt) {
          const matchingObjs = [
            activeMt.key!,
            ...findAllParent(this.menuItems, activeMt),
          ];

          // Only update active state if we found a real match; never clear bullets
          if (matchingObjs.length > 0) {
            this.activeMenuItems = matchingObjs;
            this.menuItems.forEach((menu: MenuItem) => {
              menu.collapsed = !matchingObjs.includes(menu.key!);
            });
          }
        }
        // If activeMt is null (detail route not in menu), keep existing activeMenuItems intact
      }
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param menu
   */
  hasSubmenu(menu: MenuItem): boolean {
    return menu.subMenu ? true : false;
  }

  /**
   * toggles open menu
   * @param menuItem clicked menuitem
   * @param collapse collapse instance
   */
  toggleMenuItem(menuItem: MenuItem, collapse: NgbCollapse): void {
    collapse.toggle();
    let openMenuItems: string[];
    if (!menuItem.collapsed) {
      openMenuItems = [
        menuItem.key!,
        ...findAllParent(this.menuItems, menuItem),
      ];
      this.menuItems.forEach((menu: MenuItem) => {
        if (!openMenuItems.includes(menu.key!)) {
          menu.collapsed = true;
        }
      });
    }
  }

// Hide Backdrop
  /**
   * Hides the backdrop element with the ID "custom-backdrop" by adding the "d-none" class to it.
   * Additionally, toggles the "sidebar-enable" class on the root HTML element.
   *
   * @return {void} This method does not return a value.
   */
  hideBackdrop() {
    document.getElementById('custom-backdrop')?.classList.add('d-none');
    document.documentElement.classList.toggle('sidebar-enable');
  }

}

